export const DATA_COUNTRY = {
  status: "OK",
  "status-code": 200,
  version: "1.0",
  access: "public",
  data: [
    {
      country: "Serbia",
      dial_code: "+381",
      flag: "flags/Serbia_and_Montenegro.png",
      code: "RS",
    },
    {
      country: "United States",
      dial_code: "+1",
      flag: "flags/United_States_of_America.png",
      code: "US",
    },
    {
      country: "Afghanistan",
      dial_code: "+93",
      flag: "flags/Afghanistan.png",
      code: "AF",
    },
    {
      country: "Aland Islands",
      dial_code: "+358",
      flag: "flags/Aland.png",
      code: "AX",
    },
    {
      country: "Albania",
      dial_code: "+355",
      flag: "flags/Albania.png",
      code: "AL",
    },
    {
      country: "Algeria",
      dial_code: "+213",
      flag: "flags/Algeria.png",
      code: "DZ",
    },
    {
      country: "AmericanSamoa",
      dial_code: "+1684",
      flag: "flags/American_Samoa.png",
      code: "AS",
    },
    {
      country: "Andorra",
      dial_code: "+376",
      flag: "flags/Andorra.png",
      code: "AD",
    },
    {
      country: "Angola",
      dial_code: "+244",
      flag: "flags/Angola.png",
      code: "AO",
    },
    {
      country: "Anguilla",
      dial_code: "+1264",
      flag: "flags/Anguilla.png",
      code: "AI",
    },
    {
      country: "Antigua and Barbuda",
      dial_code: "+1268",
      flag: "flags/Antigua_and_Barbuda.png",
      code: "AG",
    },
    {
      country: "Argentina",
      dial_code: "+54",
      flag: "flags/Argentina.png",
      code: "AR",
    },
    {
      country: "Armenia",
      dial_code: "+374",
      flag: "flags/Armenia.png",
      code: "AM",
    },
    {
      country: "Aruba",
      dial_code: "+297",
      flag: "flags/Aruba.png",
      code: "AW",
    },
    {
      country: "Australia",
      dial_code: "+61",
      flag: "flags/Australia.png",
      code: "AU",
    },
    {
      country: "Austria",
      dial_code: "+43",
      flag: "flags/Austria.png",
      code: "AT",
    },
    {
      country: "Azerbaijan",
      dial_code: "+994",
      flag: "flags/Azerbaijan.png",
      code: "AZ",
    },
    {
      country: "Bahamas",
      dial_code: "+1242",
      flag: "flags/Bahamas.png",
      code: "BS",
    },
    {
      country: "Bahrain",
      dial_code: "+973",
      flag: "flags/Bahrain.png",
      code: "BH",
    },
    {
      country: "Bangladesh",
      dial_code: "+880",
      flag: "flags/Bangladesh.png",
      code: "BD",
    },
    {
      country: "Barbados",
      dial_code: "+1246",
      flag: "flags/Barbados.png",
      code: "BB",
    },
    {
      country: "Belarus",
      dial_code: "+375",
      flag: "flags/Belarus.png",
      code: "BY",
    },
    {
      country: "Belgium",
      dial_code: "+32",
      flag: "flags/Belgium.png",
      code: "BE",
    },
    {
      country: "Belize",
      dial_code: "+501",
      flag: "flags/Belize.png",
      code: "BZ",
    },
    {
      country: "Benin",
      dial_code: "+229",
      flag: "flags/Benin.png",
      code: "BJ",
    },
    {
      country: "Bermuda",
      dial_code: "+1441",
      flag: "flags/Bermuda.png",
      code: "BM",
    },
    {
      country: "Bhutan",
      dial_code: "+975",
      flag: "flags/Bhutan.png",
      code: "BT",
    },
    {
      country: "Bolivia, Plurinational State of",
      dial_code: "+591",
      flag: "flags/Bolivia.png",
      code: "BO",
    },
    {
      country: "Bosnia and Herzegovina",
      dial_code: "+387",
      flag: "flags/Bosnia.png",
      code: "BA",
    },
    {
      country: "Botswana",
      dial_code: "+267",
      flag: "flags/Botswana.png",
      code: "BW",
    },
    {
      country: "Brazil",
      dial_code: "+55",
      flag: "flags/Brazil.png",
      code: "BR",
    },
    {
      country: "British Indian Ocean Territory",
      dial_code: "+246",
      flag: "flags/British_Virgin_Islands.png",
      code: "IO",
    },
    {
      country: "Brunei Darussalam",
      dial_code: "+673",
      flag: "flags/Brunei.png",
      code: "BN",
    },
    {
      country: "Bulgaria",
      dial_code: "+359",
      flag: "flags/Bulgaria.png",
      code: "BG",
    },
    {
      country: "Burkina Faso",
      dial_code: "+226",
      flag: "flags/Burkina_Faso.png",
      code: "BF",
    },
    {
      country: "Burundi",
      dial_code: "+257",
      flag: "flags/Burundi.png",
      code: "BI",
    },
    {
      country: "Cambodia",
      dial_code: "+855",
      flag: "flags/Cambodia.png",
      code: "KH",
    },
    {
      country: "Cameroon",
      dial_code: "+237",
      flag: "flags/Cameroon.png",
      code: "CM",
    },
    {
      country: "Canada",
      dial_code: "+1",
      flag: "flags/Canada.png",
      code: "CA",
    },
    {
      country: "Cape Verde",
      dial_code: "+238",
      flag: "flags/Cape_Verde.png",
      code: "CV",
    },
    {
      country: "Cayman Islands",
      dial_code: "+ 345",
      flag: "flags/Cayman_Islands.png",
      code: "KY",
    },
    {
      country: "Central African Republic",
      dial_code: "+236",
      flag: "flags/Central_African_Republic.png",
      code: "CF",
    },
    {
      country: "Chad",
      dial_code: "+235",
      flag: "flags/Chad.png",
      code: "TD",
    },
    {
      country: "Chile",
      dial_code: "+56",
      flag: "flags/Chile.png",
      code: "CL",
    },
    {
      country: "China",
      dial_code: "+86",
      flag: "flags/China.png",
      code: "CN",
    },
    {
      country: "Christmas Island",
      dial_code: "+61",
      flag: "flags/Christmas_Island.png",
      code: "CX",
    },
    {
      country: "Cocos (Keeling) Islands",
      dial_code: "+61",
      flag: "flags/Cocos.png",
      code: "CC",
    },
    {
      country: "Colombia",
      dial_code: "+57",
      flag: "flags/Colombia.png",
      code: "CO",
    },
    {
      country: "Comoros",
      dial_code: "+269",
      flag: "flags/Comoros.png",
      code: "KM",
    },
    {
      country: "Congo",
      dial_code: "+242",
      flag: "flags/Congo.jpg",
      code: "CG",
    },
    {
      country: "Cook Islands",
      dial_code: "+682",
      flag: "flags/Cook_Islands.png",
      code: "CK",
    },
    {
      country: "Costa Rica",
      dial_code: "+506",
      flag: "flags/Costa_Rica.png",
      code: "CR",
    },
    {
      country: "Cote d'Ivoire",
      dial_code: "+225",
      flag: "flags/Côte_d'Ivoire.png",
      code: "CI",
    },
    {
      country: "Croatia",
      dial_code: "+385",
      flag: "flags/Croatia.png",
      code: "HR",
    },
    {
      country: "Cuba",
      dial_code: "+53",
      flag: "flags/Cuba.png",
      code: "CU",
    },
    {
      country: "Cyprus",
      dial_code: "+357",
      flag: "flags/Cyprus.png",
      code: "CY",
    },
    {
      country: "Czech Republic",
      dial_code: "+420",
      flag: "flags/Czech_Republic.png",
      code: "CZ",
    },
    {
      country: "Denmark",
      dial_code: "+45",
      flag: "flags/Denmark.png",
      code: "DK",
    },
    {
      country: "Djibouti",
      dial_code: "+253",
      flag: "flags/Djibouti.png",
      code: "DJ",
    },
    {
      country: "Dominica",
      dial_code: "+1767",
      flag: "flags/Dominica.png",
      code: "DM",
    },
    {
      country: "Dominican Republic",
      dial_code: "+1849",
      flag: "flags/Dominican_Republic.png",
      code: "DO",
    },
    {
      country: "Ecuador",
      dial_code: "+593",
      flag: "flags/Ecuador.png",
      code: "EC",
    },
    {
      country: "Egypt",
      dial_code: "+20",
      flag: "flags/Egypt.png",
      code: "EG",
    },
    {
      country: "El Salvador",
      dial_code: "+503",
      flag: "flags/El_Salvador.png",
      code: "SV",
    },
    {
      country: "Equatorial Guinea",
      dial_code: "+240",
      flag: "flags/Equatorial_Guinea.png",
      code: "GQ",
    },
    {
      country: "Eritrea",
      dial_code: "+291",
      flag: "flags/Eritrea.png",
      code: "ER",
    },
    {
      country: "Estonia",
      dial_code: "+372",
      flag: "flags/Estonia.png",
      code: "EE",
    },
    {
      country: "Ethiopia",
      dial_code: "+251",
      flag: "flags/Ethiopia.png",
      code: "ET",
    },
    {
      country: "Falkland Islands (Malvinas)",
      dial_code: "+500",
      flag: "flags/Falkland_Islands.png",
      code: "FK",
    },
    {
      country: "Faroe Islands",
      dial_code: "+298",
      flag: "flags/Faroe_Islands.png",
      code: "FO",
    },
    {
      country: "Fiji",
      dial_code: "+679",
      flag: "flags/Fiji.png",
      code: "FJ",
    },
    {
      country: "Finland",
      dial_code: "+358",
      flag: "flags/Finland.png",
      code: "FI",
    },
    {
      country: "France",
      dial_code: "+33",
      flag: "flags/France.png",
      code: "FR",
    },
    {
      country: "French Guiana",
      dial_code: "+594",
      flag: "flags/French.png",
      code: "GF",
    },
    {
      country: "French Polynesia",
      dial_code: "+689",
      flag: "flags/French_Polynesia.png",
      code: "PF",
    },
    {
      country: "Gabon",
      dial_code: "+241",
      flag: "flags/Gabon.png",
      code: "GA",
    },
    {
      country: "Gambia",
      dial_code: "+220",
      flag: "flags/Gambia.png",
      code: "GM",
    },
    {
      country: "Georgia",
      dial_code: "+995",
      flag: "flags/Georgia.png",
      code: "GE",
    },
    {
      country: "Germany",
      dial_code: "+49",
      flag: "flags/Germany.png",
      code: "DE",
    },
    {
      country: "Ghana",
      dial_code: "+233",
      flag: "flags/Ghana.png",
      code: "GH",
    },
    {
      country: "Gibraltar",
      dial_code: "+350",
      flag: "flags/Gibraltar.png",
      code: "GI",
    },
    {
      country: "Greece",
      dial_code: "+30",
      flag: "flags/Greece.png",
      code: "GR",
    },
    {
      country: "Greenland",
      dial_code: "+299",
      flag: "flags/Greenland.png",
      code: "GL",
    },
    {
      country: "Grenada",
      dial_code: "+1473",
      flag: "flags/Grenada.png",
      code: "GD",
    },
    {
      country: "Guadeloupe",
      dial_code: "+590",
      flag: "flags/Guadeloupe.jpg",
      code: "GP",
    },
    {
      country: "Guam",
      dial_code: "+1671",
      flag: "flags/Guam.png",
      code: "GU",
    },
    {
      country: "Guatemala",
      dial_code: "+502",
      flag: "flags/Guatemala.png",
      code: "GT",
    },
    {
      country: "Guernsey",
      dial_code: "+44",
      flag: "flags/Guernsey.png",
      code: "GG",
    },
    {
      country: "Guinea",
      dial_code: "+224",
      flag: "flags/Guinea.png",
      code: "GN",
    },
    {
      country: "Guinea-Bissau",
      dial_code: "+245",
      flag: "flags/Guinea_Bissau.png",
      code: "GW",
    },
    {
      country: "Guyana",
      dial_code: "+595",
      flag: "flags/Guyana.png",
      code: "GY",
    },
    {
      country: "Haiti",
      dial_code: "+509",
      flag: "flags/Haiti.png",
      code: "HT",
    },
    {
      country: "Holy See (Vatican City State)",
      dial_code: "+379",
      flag: "flags/Holy.png",
      code: "VA",
    },
    {
      country: "Honduras",
      dial_code: "+504",
      flag: "flags/Honduras.png",
      code: "HN",
    },
    {
      country: "Hong Kong",
      dial_code: "+852",
      flag: "flags/Hong_Kong.png",
      code: "HK",
    },
    {
      country: "Hungary",
      dial_code: "+36",
      flag: "flags/Hungary.png",
      code: "HU",
    },
    {
      country: "Iceland",
      dial_code: "+354",
      flag: "flags/Iceland.png",
      code: "IS",
    },
    {
      country: "India",
      dial_code: "+91",
      flag: "flags/India.png",
      code: "IN",
    },
    {
      country: "Indonesia",
      dial_code: "+62",
      flag: "flags/Indonesia.png",
      code: "ID",
    },
    {
      country: "Iran, Islamic Republic of Persian Gulf",
      dial_code: "+98",
      flag: "flags/Iran.png",
      code: "IR",
    },
    {
      country: "Iraq",
      dial_code: "+964",
      flag: "flags/Iraq.png",
      code: "IQ",
    },
    {
      country: "Ireland",
      dial_code: "+353",
      flag: "flags/Ireland.png",
      code: "IE",
    },
    {
      country: "Isle of Man",
      dial_code: "+44",
      flag: "flags/Isle.png",
      code: "IM",
    },
    {
      country: "Israel",
      dial_code: "+972",
      flag: "flags/Israel.png",
      code: "IL",
    },
    {
      country: "Italy",
      dial_code: "+39",
      flag: "flags/Italy.png",
      code: "IT",
    },
    {
      country: "Jamaica",
      dial_code: "+1876",
      flag: "flags/Jamaica.png",
      code: "JM",
    },
    {
      country: "Japan",
      dial_code: "+81",
      flag: "flags/Japan.png",
      code: "JP",
    },
    {
      country: "Jersey",
      dial_code: "+44",
      flag: "flags/Jersey.png",
      code: "JE",
    },
    {
      country: "Jordan",
      dial_code: "+962",
      flag: "flags/Jordan.png",
      code: "JO",
    },
    {
      country: "Kazakhstan",
      dial_code: "+77",
      flag: "flags/Kazakhstan.png",
      code: "KZ",
    },
    {
      country: "Kenya",
      dial_code: "+254",
      flag: "flags/Kenya.png",
      code: "KE",
    },
    {
      country: "Kiribati",
      dial_code: "+686",
      flag: "flags/Kiribati.png",
      code: "KI",
    },
    {
      country: "Kuwait",
      dial_code: "+965",
      flag: "flags/Kuwait.png",
      code: "KW",
    },
    {
      country: "Kyrgyzstan",
      dial_code: "+996",
      flag: "flags/Kyrgyzstan.png",
      code: "KG",
    },
    {
      country: "Laos",
      dial_code: "+856",
      flag: "flags/Laos.png",
      code: "LA",
    },
    {
      country: "Latvia",
      dial_code: "+371",
      flag: "flags/Latvia.png",
      code: "LV",
    },
    {
      country: "Lebanon",
      dial_code: "+961",
      flag: "flags/Lebanon.png",
      code: "LB",
    },
    {
      country: "Lesotho",
      dial_code: "+266",
      flag: "flags/Lesotho.png",
      code: "LS",
    },
    {
      country: "Liberia",
      dial_code: "+231",
      flag: "flags/Liberia.png",
      code: "LR",
    },
    {
      country: "Libyan Arab Jamahiriya",
      dial_code: "+218",
      flag: "flags/Libya.png",
      code: "LY",
    },
    {
      country: "Liechtenstein",
      dial_code: "+423",
      flag: "flags/Liechtenstein.png",
      code: "LI",
    },
    {
      country: "Lithuania",
      dial_code: "+370",
      flag: "flags/Lithuania.png",
      code: "LT",
    },
    {
      country: "Luxembourg",
      dial_code: "+352",
      flag: "flags/Luxembourg.png",
      code: "LU",
    },
    {
      country: "Macao",
      dial_code: "+853",
      flag: "flags/Macao.png",
      code: "MO",
    },
    {
      country: "Macedonia",
      dial_code: "+389",
      flag: "flags/Macedonia.png",
      code: "MK",
    },
    {
      country: "Madagascar",
      dial_code: "+261",
      flag: "flags/Madagascar.png",
      code: "MG",
    },
    {
      country: "Malawi",
      dial_code: "+265",
      flag: "flags/Malawi.png",
      code: "MW",
    },
    {
      country: "Malaysia",
      dial_code: "+60",
      flag: "flags/Malaysia.png",
      code: "MY",
    },
    {
      country: "Maldives",
      dial_code: "+960",
      flag: "flags/Maldives.png",
      code: "MV",
    },
    {
      country: "Mali",
      dial_code: "+223",
      flag: "flags/Mali.png",
      code: "ML",
    },
    {
      country: "Malta",
      dial_code: "+356",
      flag: "flags/Malta.png",
      code: "MT",
    },
    {
      country: "Marshall Islands",
      dial_code: "+692",
      flag: "flags/Marshall_Islands.png",
      code: "MH",
    },
    {
      country: "Martinique",
      dial_code: "+596",
      flag: "flags/Martinique.png",
      code: "MQ",
    },
    {
      country: "Mauritania",
      dial_code: "+222",
      flag: "flags/Mauritania.png",
      code: "MR",
    },
    {
      country: "Mauritius",
      dial_code: "+230",
      flag: "flags/Mauritius.png",
      code: "MU",
    },
    {
      country: "Mayotte",
      dial_code: "+262",
      flag: "flags/Mayotte.png",
      code: "YT",
    },
    {
      country: "Mexico",
      dial_code: "+52",
      flag: "flags/Mexico.png",
      code: "MX",
    },
    {
      country: "Micronesia",
      dial_code: "+691",
      flag: "flags/Micronesia.png",
      code: "FM",
    },
    {
      country: "Moldova",
      dial_code: "+373",
      flag: "flags/Moldova.png",
      code: "MD",
    },
    {
      country: "Monaco",
      dial_code: "+377",
      flag: "flags/Monaco.png",
      code: "MC",
    },
    {
      country: "Mongolia",
      dial_code: "+976",
      flag: "flags/Mongolia.png",
      code: "MN",
    },
    {
      country: "Montenegro",
      dial_code: "+382",
      flag: "flags/Montenegro.png",
      code: "ME",
    },
    {
      country: "Montserrat",
      dial_code: "+1664",
      flag: "flags/Montserrat.png",
      code: "MS",
    },
    {
      country: "Morocco",
      dial_code: "+212",
      flag: "flags/Morocco.png",
      code: "MA",
    },
    {
      country: "Mozambique",
      dial_code: "+258",
      flag: "flags/Mozambique.png",
      code: "MZ",
    },
    {
      country: "Myanmar",
      dial_code: "+95",
      flag: "flags/Myanmar.png",
      code: "MM",
    },
    {
      country: "Namibia",
      dial_code: "+264",
      flag: "flags/Namibia.png",
      code: "NA",
    },
    {
      country: "Nauru",
      dial_code: "+674",
      flag: "flags/Nauru.png",
      code: "NR",
    },
    {
      country: "Nepal",
      dial_code: "+977",
      flag: "flags/Nepal.png",
      code: "NP",
    },
    {
      country: "Netherlands",
      dial_code: "+31",
      flag: "flags/Netherlands.png",
      code: "NL",
    },
    {
      country: "Netherlands Antilles",
      dial_code: "+599",
      flag: "flags/Netherlands_Antilles.png",
      code: "AN",
    },
    {
      country: "New Caledonia",
      dial_code: "+687",
      flag: "flags/New_Caledonia.png",
      code: "NC",
    },
    {
      country: "New Zealand",
      dial_code: "+64",
      flag: "flags/New_Zealand.png",
      code: "NZ",
    },
    {
      country: "Nicaragua",
      dial_code: "+505",
      flag: "flags/Nicaragua.png",
      code: "NI",
    },
    {
      country: "Niger",
      dial_code: "+227",
      flag: "flags/Niger.png",
      code: "NE",
    },
    {
      country: "Nigeria",
      dial_code: "+234",
      flag: "flags/Nigeria.png",
      code: "NG",
    },
    {
      country: "Niue",
      dial_code: "+683",
      flag: "flags/Niue.png",
      code: "NU",
    },
    {
      country: "Norfolk Island",
      dial_code: "+672",
      flag: "flags/Norfolk_Island.png",
      code: "NF",
    },
    {
      country: "Northern Mariana Islands",
      dial_code: "+1670",
      flag: "flags/North_Korea.png",
      code: "MP",
    },
    {
      country: "Norway",
      dial_code: "+47",
      flag: "flags/Norway.png",
      code: "NO",
    },
    {
      country: "Oman",
      dial_code: "+968",
      flag: "flags/Oman.png",
      code: "OM",
    },
    {
      country: "Pakistan",
      dial_code: "+92",
      flag: "flags/Pakistan.png",
      code: "PK",
    },
    {
      country: "Palau",
      dial_code: "+680",
      flag: "flags/Palau.png",
      code: "PW",
    },
    {
      country: "Palestinian Territory, Occupied",
      dial_code: "+970",
      flag: "flags/Palestinian.png",
      code: "PS",
    },
    {
      country: "Panama",
      dial_code: "+507",
      flag: "flags/Panama.png",
      code: "PA",
    },
    {
      country: "Papua New Guinea",
      dial_code: "+675",
      flag: "flags/Papua_New_Guinea.png",
      code: "PG",
    },
    {
      country: "Paraguay",
      dial_code: "+595",
      flag: "flags/Paraguay.png",
      code: "PY",
    },
    {
      country: "Peru",
      dial_code: "+51",
      flag: "flags/Peru.png",
      code: "PE",
    },
    {
      country: "Philippines",
      dial_code: "+63",
      flag: "flags/Philippines.png",
      code: "PH",
    },
    {
      country: "Pitcairn",
      dial_code: "+872",
      flag: "flags/Pitcairn.png",
      code: "PN",
    },
    {
      country: "Poland",
      dial_code: "+48",
      flag: "flags/Poland.png",
      code: "PL",
    },
    {
      country: "Portugal",
      dial_code: "+351",
      flag: "flags/Portugal.png",
      code: "PT",
    },
    {
      country: "Puerto Rico",
      dial_code: "+1939",
      flag: "flags/Puerto_Rico.png",
      code: "PR",
    },
    {
      country: "Qatar",
      dial_code: "+974",
      flag: "flags/Qatar.png",
      code: "QA",
    },
    {
      country: "Romania",
      dial_code: "+40",
      flag: "flags/Romania.png",
      code: "RO",
    },
    {
      country: "Russia",
      dial_code: "+7",
      flag: "flags/Russian_Federation.png",
      code: "RU",
    },
    {
      country: "Rwanda",
      dial_code: "+250",
      flag: "flags/Rwanda.png",
      code: "RW",
    },
    {
      country: "Reunion",
      dial_code: "+262",
      flag: "flags/Reunion.png",
      code: "RE",
    },
    {
      country: "Saint Barthelemy",
      dial_code: "+590",
      flag: "flags/Serbia_and_Montenegro.png",
      code: "BL",
    },
    {
      country: "Saint Helena, Ascension and Tristan Da Cunha",
      dial_code: "+290",
      flag: "flags/Serbia_and_Montenegro.png",
      code: "SH",
    },
    {
      country: "Saint Kitts and Nevis",
      dial_code: "+1869",
      flag: "flags/Saint_Kitts_and_Nevis.png",
      code: "KN",
    },
    {
      country: "Saint Lucia",
      dial_code: "+1758",
      flag: "flags/Saint_Lucia.png",
      code: "LC",
    },
    {
      country: "Saint Martin",
      dial_code: "+590",
      flag: "flags/Saint.png",
      code: "MF",
    },
    {
      country: "Saint Pierre and Miquelon",
      dial_code: "+508",
      flag: "flags/Saint_Pierre.png",
      code: "PM",
    },
    {
      country: "Saint Vincent and the Grenadines",
      dial_code: "+1784",
      flag: "flags/Saint_Vicent_and_the_Grenadines.png",
      code: "VC",
    },
    {
      country: "Samoa",
      dial_code: "+685",
      flag: "flags/Samoa.png",
      code: "WS",
    },
    {
      country: "San Marino",
      dial_code: "+378",
      flag: "flags/San_Marino.png",
      code: "SM",
    },
    {
      country: "Sao Tome and Principe",
      dial_code: "+239",
      flag: "flags/Sao_Tomé_and_Príncipe.png",
      code: "ST",
    },
    {
      country: "Saudi Arabia",
      dial_code: "+966",
      flag: "flags/Saudi_Arabia.png",
      code: "SA",
    },
    {
      country: "Senegal",
      dial_code: "+221",
      flag: "flags/Senegal.png",
      code: "SN",
    },
    {
      country: "Serbia",
      dial_code: "+381",
      flag: "flags/Serbia_and_Montenegro.png",
      code: "RS",
    },
    {
      country: "Seychelles",
      dial_code: "+248",
      flag: "flags/Seychelles.png",
      code: "SC",
    },
    {
      country: "Sierra Leone",
      dial_code: "+232",
      flag: "flags/Sierra_Leone.png",
      code: "SL",
    },
    {
      country: "Singapore",
      dial_code: "+65",
      flag: "flags/Singapore.png",
      code: "SG",
    },
    {
      country: "Slovakia",
      dial_code: "+421",
      flag: "flags/Slovakia.png",
      code: "SK",
    },
    {
      country: "Slovenia",
      dial_code: "+386",
      flag: "flags/Slovenia.png",
      code: "SI",
    },
    {
      country: "Solomon Islands",
      dial_code: "+677",
      flag: "flags/Soloman_Islands.png",
      code: "SB",
    },
    {
      country: "Somalia",
      dial_code: "+252",
      flag: "flags/Somalia.png",
      code: "SO",
    },
    {
      country: "South Africa",
      dial_code: "+27",
      flag: "flags/South_Africa.png",
      code: "ZA",
    },
    {
      country: "South Sudan",
      dial_code: "+211",
      flag: "flags/South_Sudan.jpg",
      code: "SS",
    },
    {
      country: "South Georgia and the South Sandwich Islands",
      dial_code: "+500",
      flag: "flags/South_Georgia.png",
      code: "GS",
    },
    {
      country: "Spain",
      dial_code: "+34",
      flag: "flags/Spain.png",
      code: "ES",
    },
    {
      country: "Sri Lanka",
      dial_code: "+94",
      flag: "flags/Sri_Lanka.png",
      code: "LK",
    },
    {
      country: "Sudan",
      dial_code: "+249",
      flag: "flags/Sudan.png",
      code: "SD",
    },
    {
      country: "Suricountry",
      dial_code: "+597",
      flag: "flags/Suriname.png",
      code: "SR",
    },
    {
      country: "Svalbard and Jan Mayen",
      dial_code: "+47",
      flag: "flags/Svalbard.png",
      code: "SJ",
    },
    {
      country: "Swaziland",
      dial_code: "+268",
      flag: "flags/Swaziland.png",
      code: "SZ",
    },
    {
      country: "Sweden",
      dial_code: "+46",
      flag: "flags/Sweden.png",
      code: "SE",
    },
    {
      country: "Switzerland",
      dial_code: "+41",
      flag: "flags/Switzerland.png",
      code: "CH",
    },
    {
      country: "Syrian Arab Republic",
      dial_code: "+963",
      flag: "flags/Syria.png",
      code: "SY",
    },
    {
      country: "Taiwan",
      dial_code: "+886",
      flag: "flags/Taiwan.png",
      code: "TW",
    },
    {
      country: "Tajikistan",
      dial_code: "+992",
      flag: "flags/Tajikistan.png",
      code: "TJ",
    },
    {
      country: "Tanzania, United Republic of Tanzania",
      dial_code: "+255",
      flag: "flags/Tanzania.png",
      code: "TZ",
    },
    {
      country: "Thailand",
      dial_code: "+66",
      flag: "flags/Thailand.png",
      code: "TH",
    },
    {
      country: "Timor-Leste",
      dial_code: "+670",
      flag: "flags/Timor-Leste.png",
      code: "TL",
    },
    {
      country: "Togo",
      dial_code: "+228",
      flag: "flags/Togo.png",
      code: "TG",
    },
    {
      country: "Tokelau",
      dial_code: "+690",
      flag: "flags/Tokelau.png",
      code: "TK",
    },
    {
      country: "Tonga",
      dial_code: "+676",
      flag: "flags/Tonga.png",
      code: "TO",
    },
    {
      country: "Trinidad and Tobago",
      dial_code: "+1868",
      flag: "flags/Trinidad_and_Tobago.png",
      code: "TT",
    },
    {
      country: "Tunisia",
      dial_code: "+216",
      flag: "flags/Tunisia.png",
      code: "TN",
    },
    {
      country: "Turkey",
      dial_code: "+90",
      flag: "flags/Turkey.png",
      code: "TR",
    },
    {
      country: "Turkmenistan",
      dial_code: "+993",
      flag: "flags/Turkmenistan.png",
      code: "TM",
    },
    {
      country: "Turks and Caicos Islands",
      dial_code: "+1649",
      flag: "flags/Turks_and_Caicos_Islands.png",
      code: "TC",
    },
    {
      country: "Tuvalu",
      dial_code: "+688",
      flag: "flags/Tuvalu.png",
      code: "TV",
    },
    {
      country: "Uganda",
      dial_code: "+256",
      flag: "flags/Uganda.png",
      code: "UG",
    },
    {
      country: "Ukraine",
      dial_code: "+380",
      flag: "flags/Ukraine.png",
      code: "UA",
    },
    {
      country: "United Arab Emirates",
      dial_code: "+971",
      flag: "flags/United_States_of_America.png",
      code: "AE",
    },
    {
      country: "United Kingdom",
      dial_code: "+44",
      flag: "flags/United_Kingdom.png",
      code: "GB",
    },
    {
      country: "Uruguay",
      dial_code: "+598",
      flag: "flags/Uruguay.png",
      code: "UY",
    },
    {
      country: "Uzbekistan",
      dial_code: "+998",
      flag: "flags/Uzbekistan.png",
      code: "UZ",
    },
    {
      country: "Vanuatu",
      dial_code: "+678",
      flag: "flags/Vanuatu.png",
      code: "VU",
    },
    {
      country: "Venezuela, Bolivarian Republic of Venezuela",
      dial_code: "+58",
      flag: "flags/Venezuela.png",
      code: "VE",
    },
    {
      country: "Vietnam",
      dial_code: "+84",
      flag: "flags/Vietnam.png",
      code: "VN",
    },
    {
      country: "Virgin Islands, British",
      dial_code: "+1284",
      flag: "flags/Serbia_and_Montenegro.png",
      code: "VG",
    },
    {
      country: "Virgin Islands, U.S.",
      dial_code: "+1340",
      flag: "flags/Virgin_Islands.png",
      code: "VI",
    },
    {
      country: "Wallis and Futuna",
      dial_code: "+681",
      flag: "flags/Wallis_and_Futuna.png",
      code: "WF",
    },
    {
      country: "Yemen",
      dial_code: "+967",
      flag: "flags/Yemen.png",
      code: "YE",
    },
    {
      country: "Zambia",
      dial_code: "+260",
      flag: "flags/Zambia.png",
      code: "ZM",
    },
    {
      country: "Zimbabwe",
      dial_code: "+263",
      flag: "flags/Zimbabwe.png",
      code: "ZW",
    },
  ],
};

export const DATA_RESOURCES = [
  {
    category: "Savezi",
    id: 1,
    data: [
      {
        id: 1,
        category: "Savezi",
        title: "Fizičke poteškoće",
        subtitle: "MS platforma Srbije ",
        link: "https://msplatforma.org.rs/about-us/?lang=en",
        created_at: "2022-06-27T14:35:07.000000Z",
        updated_at: "2022-06-29T12:13:12.000000Z",
      },
    ],
  },
  {
    category: "Udruženja",
    id: 5,
    data: [
      {
        id: 5,
        category: "Udruženja",
        title: "Fizičke poteškoće",
        subtitle:
          "Centar za samostalni život osoba sa invaliditetom  Srbije, Beograd",
        link: "http://www.cilsrbija.org/eng/index.php",
        created_at: "2022-06-27T14:46:31.000000Z",
        updated_at: "2022-06-27T14:46:31.000000Z",
      },
      {
        id: 6,
        category: "Udruženja",
        title: null,
        subtitle: "Udruženje studenata sa hendikepom",
        link: "https://ush.rs/en/home",
        created_at: "2022-06-27T14:46:31.000000Z",
        updated_at: "2022-06-27T14:46:31.000000Z",
      },
      {
        id: 7,
        category: "Udruženja",
        title: null,
        subtitle: "Društvo za cerebralnu i dečiju paralizu 'Ana Antonijević'",
        link: "https://drustvo-zacerebralnuparalizukg.business.site/",
        created_at: "2022-06-27T14:46:31.000000Z",
        updated_at: "2022-06-27T14:46:31.000000Z",
      },
      {
        id: 8,
        category: "Udruženja",
        title: " Senzorni poremećaji",
        subtitle: "Gradska organizacija gluvih Beograda.",
        link: "http://gogb.org.rs/",
        created_at: "2022-06-27T14:46:31.000000Z",
        updated_at: "2022-06-27T14:46:31.000000Z",
      },
    ],
  },
  {
    category: "Nevladine organizacije",
    id: 9,
    data: [
      {
        id: 9,
        category: "Nevladine organizacije",
        title: null,
        subtitle: "Mreža organizacija za decu iz Srbije",
        link: "http://zadecu.org/en/",
        created_at: "2022-06-27T15:11:41.000000Z",
        updated_at: "2022-07-06T09:22:56.000000Z",
      },
      {
        id: 10,
        category: "Nevladine organizacije",
        title: null,
        subtitle: "Organization littleBig people",
        link: "https://malivelikiljudi.com/en/",
        linkAnother: "https://malivelikiljudi.com/sr/",
        created_at: "2022-06-27T15:11:41.000000Z",
        updated_at: "2022-07-06T09:23:04.000000Z",
      },
      {
        id: 11,
        category: "Nevladine organizacije",
        title: null,
        subtitle: "Viva Udruženje za pomoć deci",
        link: "http://vivapomocdeci.org/en/",
        created_at: "2022-06-27T15:11:41.000000Z",
        updated_at: "2022-07-06T09:23:08.000000Z",
      },
      {
        id: 12,
        category: "Nevladine organizacije",
        title: null,
        subtitle: "Fondacija Anđela",
        link: "https://fondacijaandjela.org/en/",
        created_at: "2022-06-27T15:11:41.000000Z",
        updated_at: "2022-07-06T09:23:15.000000Z",
      },
      {
        id: 13,
        category: "Nevladine organizacije",
        title: null,
        subtitle: "Centar živeti uspravno Novi Sad",
        link: "https://www.czuns.org/en/",
        created_at: "2022-06-27T15:11:41.000000Z",
        updated_at: "2022-07-06T09:23:20.000000Z",
      },
      {
        id: 14,
        category: "Nevladine organizacije",
        title: null,
        subtitle: "Ekumenska humanitarna organizacija",
        link: "http://ehons.org/en/",
        created_at: "2022-06-27T15:11:41.000000Z",
        updated_at: "2022-07-06T09:23:25.000000Z",
      },
      {
        id: 15,
        category: "Nevladine organizacije",
        title: null,
        subtitle: "Pomoć Srpskoj deci",
        link: "https://en.pomocsrpskojdeci.com/",
        created_at: "2022-06-27T15:11:41.000000Z",
        updated_at: "2022-07-06T09:23:30.000000Z",
      },
      {
        id: 16,
        category: "Nevladine organizacije",
        title: null,
        subtitle: "Otvoreni klub - Društvo za razvoj dece i mladih",
        link: "https://oknis.org.rs/en/",
        created_at: "2022-06-27T15:11:41.000000Z",
        updated_at: "2022-07-06T09:23:44.000000Z",
      },
      {
        id: 17,
        category: "Nevladine organizacije",
        title: null,
        subtitle:
          "Nacionalna organizacija osoba sa invaliditetom Srbije (NOOIS)",
        link: "https://noois.rs/english",
        created_at: "2022-06-27T15:11:41.000000Z",
        updated_at: "2022-07-06T09:23:48.000000Z",
      },
    ],
  },
  {
    category: "Zakoni, propisi i priručnici",
    id: 18,
    data: [
      {
        id: 18,
        category: "Zakoni, propisi i priručnici",
        title: null,
        subtitle: "Centar za prava deteta",
        link: "https://cpd.org.rs/?lang=en",
        created_at: "2022-06-27T15:13:05.000000Z",
        updated_at: "2022-07-06T09:24:13.000000Z",
      },
      {
        id: 19,
        category: "Zakoni, propisi i priručnici",
        title: null,
        subtitle:
          "Položaj dece sa smetnjama u razvoju i invaliditetom u Republici Srbiji",
        link: "https://www.unicef.org/serbia/en/position-children-disabilities-republic-serbia",
        created_at: "2022-06-27T15:13:05.000000Z",
        updated_at: "2022-07-06T09:24:25.000000Z",
      },
    ],
  },
];

export const DATA_FAQ = [
  {
    main_category: "Sigurnost i verifikacija",
    id: 8,
    data: [
      {
        main_category: "Sigurnost i verifikacija",
        category: null,
        sub_category: null,
        question: "Kako da znam da li član ima verifikovan profil?",
        answer:
          '<p>Da bi zaštitili naše članove, tim SensCare je usvojio nekoliko načina za verifikaciju profila. Svi naši članovi moraju da verifikuju svoj broj telefona i <br> e-mail adresu. Stoga, možete proveriti da li član ima verifikovani nalog na društvenoj mreži prateći ove korake:&nbsp;\r\n            idite na profil člana <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n            \r\n                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                            <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n                        </g>\r\n                    </svg></strong> zatim otvorite odeljak <strong>„Sigurnost i verifikacija</strong>”. Zlatni simbol društvene mreže znači da je nalog verifikovan &nbsp;&nbsp; <img src="https://admin.stage.mysenscare.com/assets/cms/Group 500.svg">&nbsp; <img src="https://admin.stage.mysenscare.com/assets/cms/Twitter.svg">&nbsp; <img src="https://admin.stage.mysenscare.com/assets/cms/Instagram.svg">&nbsp; <img src="https://admin.stage.mysenscare.com/assets/cms/LinkedIn.svg"><br>\r\n            Pored toga, zlatni simboli na profilu člana su pokazatelji verifikovanih naloga <img src="https://admin.stage.mysenscare.com/assets/cms/Vector.svg">&nbsp; <img src="https://admin.stage.mysenscare.com/assets/cms/Vector (1).svg">&nbsp;<img src="https://admin.stage.mysenscare.com/assets/cms/account_circle_24px.svg">&nbsp;<img src="https://admin.stage.mysenscare.com/assets/cms/Vector (2).svg"></p>',
      },
      {
        main_category: "Sigurnost i verifikacija",
        category: null,
        sub_category: null,
        question:
          "Kako da prijavim člana zbog sigurnosnih razloga ili neprimerenog ponašanja?",
        answer:
          '<p>Ako smatrate da člana treba prijaviti, idite na korisnikov profil i kliknite na dugme koje izgleda kao ljubičasti simbol &nbsp; <img src="https://admin.stage.mysenscare.com/assets/cms/Group 1773.svg" /> &nbsp;ruke odmah pored fotografije člana. Od vas će se tražiti da date kratak opis situacije. Kada primimo izveštaj, SensCare tim će preduzeti korake da dodatno istraži okolnosti.</p>',
      },
      {
        main_category: "Sigurnost i verifikacija",
        category: null,
        sub_category: null,
        question: "Zašto moram da verifikujem svoj broj telefona?",
        answer:
          "<p>Da bi mogli da verifikujemo naše nove članove i dodamo dodatni nivo zaštite, svi SensCare korisnici moraju da verifikuju svoj broj telefona. Vaš telefonski broj će biti zaštićen i ostali članovi neće imati pristup vašem telefonskom broju.</p>",
      },
      {
        main_category: "Sigurnost i verifikacija",
        category: null,
        sub_category: null,
        question: "Koji su lični podaci vidljivi  drugim članovima?",
        answer:
          "<p>SensCare tim razume koliko je važno zaštititi vaše lične podatke i stoga će jedini podaci dostupni ostalim članovima biti: vaše ime i prezime, godine starosti, grad i poštanski broj.</p>",
      },
      {
        main_category: "Sigurnost i verifikacija",
        category: null,
        sub_category: null,
        question: "Da li su moji lični podaci zaštićeni na platformi SensCare?",
        answer:
          "<p>Da, vaši lični podaci su zaštićeni na SensCare i vaši lični podaci (kao što su broj telefona i kućna adresa) neće biti vidljivi i neće biti deljeni sa drugim članovima. </p>",
      },
      {
        main_category: "Sigurnost i verifikacija",
        category: null,
        sub_category: null,
        question: "Zašto je SensCare stopirao moj nalog?",
        answer:
          "<p>SensCare ima pravo da stopira nalog korisnika ako su potvrđeni navodi protiv korisnika (ovi navodi mogu uključivati, ali nisu ograničeni na: neželjene poruke, neetično ponašanje, neuspeh prilikom verifikacije). Vaša sigurnost nam je veoma važna; stoga uvek težimo da našim članovima pružimo sigurno okruženje.</p>",
      },
    ],
  },
  {
    main_category: "Upravljanje nalogom",
    id: 14,
    data: [
      {
        main_category: "Upravljanje nalogom",
        category: null,
        sub_category: null,
        question: "Kako mogu da izmenim svoje lične podatke?",
        answer:
          '<p>Ako želite da ažurirate svoje lične podatke, idite u <strong>Podešavanja &nbsp;<svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none"><path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path></g></svg> Nalog </strong>&nbsp; <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none"><path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path></g></svg>i odaberite <strong>Lične informacije</strong>. Kada otvorite odeljak <strong>Lične informacije</strong> <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none"><path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path></g></svg> kliknite na <strong>Izmeni</strong> u gornjem desnom uglu, a zatim ažurirajte informacije koje želite.</p>',
      },
      {
        main_category: "Upravljanje nalogom",
        category: null,
        sub_category: null,
        question:
          "Zaboravio/la sam lozinku ili e-mail adresu, kako da ih povratim?",
        answer:
          "<p>Jednom kada kliknete na prijavi se, odaberite dugme &ldquo;<strong>zaboravili ste lozinku</strong>&rdquo; i sledite uputstva..&nbsp;</p>",
      },
      {
        main_category: "Upravljanje nalogom",
        category: null,
        sub_category: null,
        question:
          "Želim da zatvorim svoj nalog, koje korake treba da preduzmem?",
        answer:
          '<p>Žao nam je što odlazite! Ako želite da zatvorite svoj nalog, posetite <strong>Podešavanja <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none"><path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path></g></svg> Nalog <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none"><path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path></g></svg> Deaktiviraj/Izbriši nalog</strong> <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none"><path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path></g></svg>     <br>i odatle odaberite da li želite da nalog trajno izbrišete ili trenutno onemogućite. Ako niste sigurni šta želite da uradite sa nalogom, preporučujemo vam da onemogućite nalog jer će vaši podaci biti sačuvani i biće vam dostupni kada ponovo aktivirate nalog. Imajte na umu da ako odlučite da izbrišete svoj nalog, svi podaci će biti trajno uklonjeni sa SensCare.</p>',
      },
    ],
  },
  {
    main_category: "Upravljanje profilom i sadržajem",
    id: 17,
    data: [
      {
        main_category: "Zašto moram da postavim medije i kako to da uradim?",
        category: "Upravljanje profilom",
        sub_category: null,
        question: "Zašto moram da postavim medije i kako to da uradim?",
        answer:
          "<p>Kako SensCare teži stvaranju sigurnog i interaktivnog okruženja, posedovanje fotografije na profilu pomoći će da se bolje povežete sa drugim članovima, jer će dati ličniji dodir tokom početnih interakcija. Tokom popunjavanja profila, od vas će biti zatraženo da postavite profilnu sliku i/ ili video klikom na <strong>„postavi</strong>&rdquo; simbol.</p>",
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Upravljanje profilom",
        sub_category: null,
        question: "Kako napraviti video kako bih se najbolje predstavio/la?",
        answer:
          "<p>Preporučili bismo da napravite kratki video (ne duži od 2 minuta) koji najbolje pokazuje vaše profesionalne kvalitete. Prilikom pravljenja videa uzmite u obzir: vaše iskustvo sa decom, šta vas motiviše da radite sa decom, koja je vaša filozofija učenja, koje su vaše najznajčajnije prednosti u odnosu na druge kandidate, šta volite da radite u slobodno vreme, i slično.</p>",
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Upravljanje profilom",
        sub_category: null,
        question: "Šta predstavlja svaka ikonica na stranici profila?",
        answer:
          '<p>Ikonice na profilu člana pokazuju da li je član verifikovao svaki podatak. Ako je ikonica zlatne boje, to znači da je član verifikovao tu informaciju, ako je siva boja informacija nije verifikovana.</p>\r\n\r\n<p><strong>Objašnjenje ikonica (za sve korisnike)</strong></p>\r\n\r\n<p><img src="https://admin.stage.mysenscare.com/assets/cms/Vector (5).svg" />&nbsp; Broj telefona<br />\r\n\r\n<img src="https://admin.stage.mysenscare.com/assets/cms/Group 924.svg" />&nbsp; Emejl<br />\r\n<img src="https://admin.stage.mysenscare.com/assets/cms/account_circle_24px.svg"  />&nbsp; Uverenje o ne(kažnjavanju) <br /> \r\n<img src="https://admin.stage.mysenscare.com/assets/cms/Group 500.svg" />&nbsp;Soc medija<br />\r\n<img src="https://admin.stage.mysenscare.com/assets/cms/videocam_24px.svg" />&nbsp; Video<br />\r\n<img src="https://admin.stage.mysenscare.com/assets/cms/Group 1773.svg" />&nbsp;Prijavi<br />\r\n<img src="https://admin.stage.mysenscare.com/assets/cms/Shape.svg" /> &nbsp;Podeli profil&nbsp;</p>\r\n\r\n<p><strong>Opis ikonica (kandidati)</strong></p>\n' +
            '\n' +
            '<p>\n' +
            '    <img src="https://admin.stage.mysenscare.com/assets/cms/Group 1806.svg" style="vertical-align: middle; margin-right: 10px; margin-bottom: 3px; margin-top: 3px;" />\n' +
            '    <span class="faq-professions">Defektolog</span><br />\n' +
            '    <img src="https://admin.stage.mysenscare.com/assets/cms/Group 337.svg" style="vertical-align: middle; margin-right: 10px; margin-bottom: 3px; margin-top: 3px;" />\n' +
            '    <span class="faq-professions">Pedagoški asistent</span><br />\n' +
            '    <img src="https://admin.stage.mysenscare.com/assets/cms/Group 335.svg" style="vertical-align: middle; margin-right: 10px; margin-bottom: 3px; margin-top: 3px;" />\n' +
            '    <span class="faq-professions">Dadilja</span><br />\n' +
            '    <img src="https://admin.stage.mysenscare.com/assets/cms/Group 339.svg" style="vertical-align: middle; margin-right: 10px; margin-bottom: 3px; margin-top: 3px;" />\n' +
            '    <span class="faq-professions">Tutor</span>\n' +
            '</p>\n',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Upravljanje profilom",
        sub_category: null,
        question: "Zašto ne mogu da pristupim nekim funkcijama na SensCare?",
        answer:
          '<p>Iako je većina funkcija dostupna svim korisnicima, neke funkcije su dostupne samo Premium članovima.&nbsp;<br />\r\nAko želite da dokupite komprehenzivniji plan i dobijete celokupan pristup našim uslugama, možete to uraditi na dva načina &ldquo;dokupi premium plan&rdquo; na zlatnoj traci na početnoj stranici i posetite  <strong>Podešavanja <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Nalog <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Plaćanje i SensCare Plan</strong> <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg>&nbsp; i odaberite &ldquo;<strong>Promeni plan</strong>&rdquo; odatle ćete biti u mogućnosti da odaberete novi plan.&nbsp;</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za Roditelje",
        sub_category: "Posao/Intervju",
        question: "Da li je SensCare odgovoran da mi nađe osobu za rad?",
        answer:
          "<p>SensCare je platforma koja povezuje poslodavca i osobe koje traže posao u domenu dečijih usluga, ali SensCare nije direktno odgovoran za pronalaženje osobe za rad. SensCare je uvek tu da vas podrži ako imate pitanja ili nedoumice. Međutim, naš premium paket članstva daje vam mogućnost da koristite SensCare izbor kandidata. Da biste iskoristili ovu funkciju, dokupite naš Premium paket.</p>",
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za Roditelje",
        sub_category: "Posao/Intervju",
        question:
          "Ako angažujem kandidata preko SensCare platforme koji živi u drugoj državi, da li ćete mi pomoći u procesu podnošenja zahteva za vizu?",
        answer:
          '<p>lako smo oduševljeni što ste našli izvrsnog kandidata, SensCare trenutno nije u mogućnosti da vam pomogne u obradi vize / radne dozvole za vašeg budućeg zaposlenog i stoga neće snositi odgovornost za pružanje bilo kakvih pravnih dokumenata, uključujući ugovor između vas i budućeg zaposlenog. Da biste osigurali uspešnost odabira pravog kandidata posetite naš <a href="/safety-center#safety_tips">Sigurnosni centar</a>. Takođe, za više informacija o postupku podnošenja zahteva za vizu, posetite ambasadu ili konzulat zemlje u kojoj živite.&nbsp;<br />\r\n&nbsp;</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za Roditelje",
        sub_category: "Posao/Intervju",
        question:
          "Tražim dadilju i/ili profesionalnog pružaoca dečijih usluga, kako da objavim oglas za posao?",
        answer:
          '<p>Ovo je uzbudljiv trenutak! Da biste napravili novi oglas za posao, kliknite ljubičastu ikonicu &ldquo;<strong>oglas</strong>&rdquo; koja se nalazi u desnom gornjem uglu pored slike vašeg profila. Takođe, možete da posetite sekciju <strong>Istorija Poslova i Dokumenta</strong>  i izaberete ljubičasti simbol  <img src="https://admin.stage.mysenscare.com/assets/cms/Group 2258.svg"/>  „dodaj posao“. <br />Od vas će se tražiti da unesete naslov oglasa za posao i napišete kratak opis posla. Jednom kada objavite oglas budite strpljivi i mnoge dadilje i ostali profesionalni pružaoci dečjih usluga će vas konktatirati.&nbsp;<br />\r\n&nbsp;</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za Roditelje",
        sub_category: "Posao/Intervju",
        question: "Kako mogu da uredim oglas za posao?",
        answer:
          "<p>Da biste uredili oglas za posao, posetite odeljak <strong> Istorija Poslova i Dokumenta</strong>  i odaberite oglas koji želite da uredite. Tada ćete biti preusmereni na novu stranicu na kojoj možete da kliknete na &ldquo;<strong>uredi oglas</strong>&rdquo; dugme i ažurirate svoju objavu.</p>",
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za Roditelje",
        sub_category: "Posao/Intervju",
        question: "Želim da zatvorim oglas za posao, kako da to uradim?",
        answer:
          "<p>Da biste zatvorili oglas za posao, posetite sekciju <strong>Istorija Poslova i Dokumenta</strong> i odaberite oglas koji želite da zatvorite. Tada ćete biti preusmereni na novu stranicu na kojoj možete da kliknete na dugme  &ldquo;<strong>zatvori oglas</strong>&rdquo; i od vas će se tražiti da potvrdite da li želite da zatvorite oglas za posao. Takođe, aktivan posao možete deaktivirati sa stranice  <strong>Vidi / Uredi</strong> profil pomoću kliznog dugmeta.</p>",
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za Roditelje",
        sub_category: "Posao/Intervju",
        question:
          "Pronašao/la sam dadilju i/ili  profesionalnog pružaoca dečijih usluga, kako da pošaljem poziv na intervju?",
        answer:
          '<p>Ovo je uzbudljiv trenutak! Da biste poslali poziv na intervju posetite <strong>profil člana</strong> i kliknite na\r\n        &ldquo;<strong>pozovi na intervju</strong>&rdquo; ljubičasto dugme koje se nalazi u desnom gornjem delu profila člana.<span class="interview">Poziv za intervju</span> Vaša idealna dadilja i/ili profesionalni pružalac dečijih usluga je odmah iza ugla.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za Roditelje",
        sub_category: "Posao/Intervju",
        question:
          "Kako mogu da kontaktiram dadilju i / ili profesionalnog pružaoca dečijih usluga?",
        answer:
          '<p>Veoma nam je drago što ste našli potencijalnog kandidata. Ako želite da kontaktirate kandidata, potrebno je da pošaljete poziv na intervju. Da biste to uradili, posetite profil člana i kliknite ljubičasto dugme “<strong>Poziv na intervju</strong>” koji se nalazi u desnom gornjem delu profilne stranice člana. &nbsp; <span class="interview">poziv na intervju</span><br>\r\n            Ako član prihvati vaš intervju, bićete obavešteni i odatle ćete moći da ga kontaktirate putem našeg centra za poruke. Da biste pristupili porukama, morate da imate plaćeni paket. Kliknite <a href="javascript: void(0)">ovde</a> da biste dokupili \r\n                paket.&nbsp;<br>\r\n                &nbsp;</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za Roditelje",
        sub_category: "Posao/Intervju",
        question: "Šta da uradim ako član ne dođe na intervju?",
        answer:
          "<p>Iako je SensCare pružio sjajne smernice o tome kako da se sprovede efikasan intervju i koliko je važno da se iskaže poštovanje prilikom intervjua, nažalost u nekim slučajevima se mogu dogoditi neočekivane stvari. Prvi korak bi bio da proverite da li vas je član kontaktirao putem naše platforme i šta je razlog za propuštanje intervjua. Ako smatrate da je član pokazao neprofesionalno ponašanje, bilo bi najbolje da prekinete dalju komunikaciju sa kandidatom.</p>",
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za Roditelje",
        sub_category: "Posao/Intervju",
        question:
          "Šta ako tokom intervjua ili nakon što zaposlim dadilju i/ili profesionalnog pružaoca dečijih usluga uvidim neprofesionalno ponašanje?",
        answer:
          '<p>Iako se SensCare trudi da obezbedi sigurno okruženje među našim članovima kroz strog postupak verifikacije, i\r\n         dalje toplo preporučujemo da posetite naš <a href="/safety-center#safety_tips">Sigurnosni centar</a> i pročitate naše savete\r\n        u vezi intervju procesa. Ako se tokom ili nakon intervjua dogodi neko neprofesionalno ponašanje, podstičemo vas\r\n        da prijavite kandiata. Pročitajte više <a href="javascript:void(0)" id="question1">ovde</a> kako biste prijavili\r\n        kandidata. Ako postoje ozbiljna kršenja vaših prava ili je ugrožena bezbednost vaše porodice, odmah kontaktirajte\r\n        nadležne organe u vašem području.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za Roditelje",
        sub_category: "Zatraži dokumenta",
        question: "Kako mogu da zatražim uverenje o (ne)kažnjavanju?",
        answer:
          '<p>Srećni smo što ste pronašli potencijalnog kandidata da radi sa vašim detetom. Da biste zatražili potvrdu o neosuđivanosti, idite na profil člana i kliknite na “<strong>zatraži dokumenta</strong>\'\' koji se nalazi u gornjem desnom uglu &nbsp;<img class="imgmrgn" src="request.png" width="150"><br>\r\n           Od vas će biti zatraženo da odaberete dokument, zatim kliknite na “ <strong>uverenje o (ne)kažnjavanju</strong>” &nbsp;i pošaljite svoj zahtev.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za Roditelje",
        sub_category: "Zatraži dokumenta",
        question:
          "Kako zatražiti CV i preporuke od člana putem platforme SensCare?",
        answer:
          '<p>Srećni smo što ste pronašli potencijalnog kandidata da radi sa vašim detetom. Da biste zatražili CV i / ili preporuku, idite na profil člana i kliknite na dugme &nbsp;<img src="../request.png" width="150" class="imgmrgn">        koje se nalazi u gornjem desnom uglu. Od vas će biti zatraženo da odaberete dokument, a zatim kliknite na “<strong>CV</strong>” i / ili\r\n        “<strong>Preporuka</strong>” &nbsp; i pošaljite svoj zahtev.</p>',
      },

      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za Roditelje",
        sub_category: "Zatraži dokumenta",
        question: "Dobio/la sam zahtev za preporuku, šta je sledeći korak?",
        answer:
          '<p>To su sjajne vesti! Da bi se članovima pomoglo u budućem zaposlenju, pismo preporuke je veoma važno.&nbsp;<br />\r\nPosetite <strong>Istoriju Poslova i Dokumenta</strong> <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> <strong>Zahtevi za preporuke</strong> i izaberite kojem članu želite da pošaljete preporuku. Potom, kliknite na &ldquo;<strong>napiši preporuku</strong>&rdquo; dugme koje se nalazi u poruci koju vam je član poslao. Dalje će biti zatraženo da podelite pismo preporuke u obliku .pdf ili .docx fajla. Nakon toga kliknite &ldquo;<strong>pošalji preporuku</strong>&rdquo; dugme.</p>',
      },

      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Posao/Intervju",
        question: "Da li je SensCare odgovoran da mi nađe posao?",
        answer:
          "<p>SensCare je platforma koja povezuje poslodavca i osobu koja traži posao, ali SensCare nije odgovoran za pronalaženje posla. SensCare tim je uvek tu da vas podrži ako imate pitanja ili nedoumice.</p>",
      },

      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Posao/Intervju",
        question: "Našao sam sjajan oglas za posao, kako da se prijavim?",
        answer:
          '<p>Ovo su odlične vesti! Posetite profil člana, kliknite na <strong>Oglasi za posao <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Prijavi se za posao.</strong></p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Posao/Intervju",
        question:
          "Ako me neko angažuje za posao u inostranstvu, da li će mi SensCare pomoći oko zahteva za vizu?",
        answer:
          "<p>Iako smo veoma srećni što ste dobili priliku da radite u inostranstvu, SensCare trenutno nije u mogućnosti da vam pomogne u dobijanju vize / radne dozvole i stoga neće snositi odgovornost za pružanje bilo kakvih pravnih dokumenata, uključujući ugovor između vas i vašeg poslodavca. Za više informacija o postupku podnošenja zahteva za vizu, posetite ambasadu ili konzulat države u kojoj ste dobili posao.</p>",
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Posao/Intervju",
        question:
          "Prijavio/la sam se za preko 10 poslova, ali me još niko nije zaposlio, šta da radim?",
        answer:
          '<p>Razumemo da ovo može predstavljati frustrirajuću situaciju. U nekim slučajevima se desi da protekne malo vremena pre nego što korisnik primi ponudu za posao. Budite strpljivi, i uvek proverite da li se vaš profil poklapa opisu i zahtevima posla, i da li imate dovoljno iskustva za taj posao.&nbsp;<br />\r\nTakođe, imajte na umu da je SensCare tim uvek tu da vas podrži, samo treba da nas  <a href="/contact-us">kontaktirate</a>.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Posao/Intervju",
        question: "Kako mogu biti siguran/na da će porodica izvršiti uplatu?",
        answer:
          '<p>Da biste osigurali pronalazak posla kod pouzdane porodice, posetite naš <a href="/safety-center">Sigurnosni centar</a> i pročitajte više o intervju procesu i naše <a href="/safety-center">saveta o bezbednosti</a> kako biste se pripremili za traženje posla. U nekim slučajevima, poslodavac i zaposleni mogu da potpišu ugovor koji jasno opisuje dužnosti i plaćanje. Međutim, ako naiđete na bilo kakve poteškoće sa porodicom, pročitajte više <a href="javascript:void(0)" id="question2">ovde</a> kako da prijavite profil.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Posao/Intervju",
        question: "Ko odlučuje visinu zarade?",
        answer:
          "<p>SensCare ne učestvuje u odlučivanju visine vaše zarade. Na vašem profilu, imate slobodu da objavite željenu sumu po satu za svoje usluge. Ako niste sigurni kako da odredite svoju satnicu, preporučujemo vam da uzmete u obzir nekoliko faktora, kao što su: nivo obrazovanja, godine radnog iskustva i lokacija na kojoj želite da se zaposlite. Takođe, možete posetiti profile drugih kandidata da biste videli njihovu prosečnu satnicu za pružanje istih usluga na vašoj lokaciji. Konačno, na osnovu našeg iskustva, krajnja satnica se uvek odlučuje između poslodavca i zaposlenog.</p>",
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Posao/Intervju",
        question: "Dobio/la sam poziv za intervju, šta je sledeće?",
        answer:
          '<p>Ovo su odlične vesti! Posetite sekciju <strong>Obaveštenja </strong> ili <strong>Istorija Poslova i Dokumenta <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Pozivi na intervju</strong> i odaberite poruku od člana koji vas je pozvao na intervju. Imaćete mogućnost da prihvatite poziv na intervju i posetite profil, ili da ga odbijete. SensCare toplo preporučuje da pregledate profil člana pre nego što prihvatite poziv na intervju. Molimo vas da posetite naš Sigurnosni centar radi <a href="/safety-center">saveta o bezbednosti</a> i da saznate više o intervju procesu.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Posao/Intervju",
        question: "Kako da se pripremim za intervju?",
        answer:
          '<p>Molimo vas da posetite naš <a href="/safety-center">Sigurnosni centar</a> kako biste dobili savete da se najbolje pripremite za intervju.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Posao/Intervju",
        question: "Kako mogu da kontaktiram porodicu ili školu?",
        answer:
          "<p>Možete započeti kontakt prijavljivanjem na aktivan oglas za posao. Ako porodica ili škola veruje da ste odgovarajuć kandidat, mogu vas kontaktirati putem poruka direktno na SensCare platformi  i onda ćete moći nastaviti dalju komunikaciju. Takođe, porodica ili škola može započeti kontakt slanjem poziva na intervju. Ako prihvatite poziv za intervju, porodica ili škola će biti obavešteni i odatle ćete moći da kontaktirate člana putem našeg centra za poruke. Da biste pristupili porukama, morate imati plaćeni plan. Dokupite svoj plan danas kako bi imali kompletan pristup svim funkcijama na SensCare platformi.&nbsp;</p>",
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Posao/Intervju",
        question:
          "Šta ako se tokom intervjua ili nakon što sam zaposlen/na dogodi neko neprofesionalno ponašanje?",
        answer:
          '<p>Iako se SensCare tim trudi da obezbedi sigurno okruženje među našim članovima kroz strog postupak verifikacije, i dalje toplo preporučujemo da posetite naš Sigurnosni centar  i pročitate naše  <a href="/safety-center">savete o bezbednosti</a> pre intervjua. Ako se tokom ili nakon intervjua dogodi neko neprofesionalno ponašanje, podstičemo vas da prijavite korisnika klikom na ikonicu ruke &nbsp;<img src="https://admin.stage.mysenscare.com/assets/cms/Group 1773.svg" /> &nbsp; na profilu tog člana. Ako postoje ozbiljna kršenja vaših prava ili bezbednosti, odmah kontaktirajte nadležne organe u vašem području.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Zahtevi za dokumenta",
        question:
          "Porodica/ ili škola traži uverenje o neosuđivanosti, kako da pošaljem uverenje?",
        answer:
          '<p>Čini se da ste na korak do pronalaska vašeg posla iz snova. Posetite <strong>Obaveštenja <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Zahtevi za dokumenta</strong> ili <strong>Istoriju Poslova i  Dokumenta <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Zahtevi za dokumenta</strong> i zatim izaberite poruku od člana koji je potražio uverenje o (ne)kažnjavanju. Kada se poruka otvori, kliknite na dugme „pošalji dokumenta“. Tada će biti zatraženo da postavite vaš dokument; izaberete uverenje o (ne)kažnjavanju i kliknite na &ldquo;nastavi&rdquo;.&nbsp;</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Zahtevi za dokumenta",
        question:
          "Koliko često treba da postavim novo uverenje o (ne)kažnjavanju?",
        answer:
          "<p>Da bi osigurao sigurnost svih članova, SensCare preporučuje da uverenje o (ne)kažnjavanju nije starije od 6 meseci.</p>",
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Zahtevi za dokumenta",
        question:
          "Kako mogu da pošaljem prateću dokumentaciju, poput biografije ili preporuka?",
        answer:
          '<p>Čini se da ste na korak do pronalaska posla iz snova. Posetite  <strong>Obaveštenja <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10"\r\n            viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"  stroke="none">\r\n                <path\r\n                    d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z" />\r\n            </g>\r\n        </svg> Zahtevi za dokumenta ili Istoriju Poslova i Dokumenta  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10"\r\n            viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"  stroke="none">\r\n                <path\r\n                    d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z" />\r\n            </g>\r\n        </svg> Zahtevi za dokumenta</strong>.Kada se otvori poruka člana, kliknite na dugme &ldquo;pošalji dokumente&rdquo;. Tada će biti zatraženo da odaberete svoja dokumenta, te odaberite dokument koji želite da pošaljete i kliknite na &ldquo;<strong>nastavi</strong>&rdquo;. Takođe, možete da posetite <strong>Istoriju Poslova i dokumenta  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10"\r\n            viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"  stroke="none">\r\n                <path\r\n                    d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z" />\r\n            </g>\r\n        </svg> Moja dokumenta</strong> i koristeći simbol za deljenje <img src="https://admin.stage.mysenscare.com/assets/cms/Shape (1).svg" /> pošaljite dokumenat članu.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Za kandidate",
        sub_category: "Zahtevi za dokumenta",
        question: "Kako mogu da zatražim preporuku od porodice/ili škole?",
        answer:
          '<p>Drago nam je da čujemo da ste imali pozitivno iskustvo sa članovima SensCare platforme. Da biste zatražili preporuku, posetite profil člana i kliknite na “<strong>zatraži preporuku</strong>” &nbsp; <img class="imgmrgn" src="../../../../public/preporuku.png" width="150"> &nbsp;ispod “<strong>O meni</strong>” sekcije.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Ocene",
        sub_category: null,
        question: "Član mi je dao lošu ocenu, šta da radim?",
        answer:
          '<p>Shvatamo da je ovo neprijatno iskustvo, ali SensCare nema pravo da menja recenzije koje su članovi postavili. Savetovali bismo vas da proverite u samoj recenziji čime je član bio nezadovoljan i poboljšate taj aspekt u budućnosti. Uvek možete kontaktirati SensCare podršku da biste dobili neke ideje. Ako se član služio uvredljivim jezikom, molimo vas da prijavite &nbsp; <img src="https://admin.stage.mysenscare.com/assets/cms/Group 1773.svg" /> &nbsp; člana i mi ćemo dalje istražiti vašu prijavu.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Ocene",
        sub_category: null,
        question: "Želim da objavim ocenu, kako to mogu da uradim?",
        answer:
          '<p>Nadamo se da ste zadovoljni saradnjom sa članom SensCare platforme. Da biste ostavili ocenu, idite na profil člana i kliknite na zvezdice da biste ocenili  &nbsp; <img src="https://admin.stage.mysenscare.com/assets/cms/Vector (Stroke).svg" /><img src="https://admin.stage.mysenscare.com/assets/cms/Vector (Stroke).svg" /><img src="https://admin.stage.mysenscare.com/assets/cms/Vector (Stroke).svg" /><img src="https://admin.stage.mysenscare.com/assets/cms/Vector (Stroke).svg" /><img src="https://admin.stage.mysenscare.com/assets/cms/Vector (Stroke) (1).svg" /> &nbsp;člana ili to možete učiniti u sekciji <strong>Ocene</strong> na vašem profilu. <br />\r\n&nbsp;</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Ponude",
        sub_category: null,
        question:
          "Preuzeo/la sam odličnu promotivnu ponudu, kako mogu da je iskoristim?",
        answer:
          '<p>Drago nam je da ste pronašli pravu uslugu ili proizvod za vas!&nbsp;<br />\r\nPratite ovu putanju: Prijavite se na svoj nalog <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10"\r\n            viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"  stroke="none">\r\n                <path\r\n                    d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z" />\r\n            </g>\r\n        </svg> Promocije <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10"\r\n            viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"  stroke="none">\r\n                <path\r\n                    d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z" />\r\n            </g>\r\n        </svg> Preuzete ponude <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10"\r\n            viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"  stroke="none">\r\n                <path\r\n                    d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z" />\r\n            </g>\r\n        </svg> i Prikaži ponudu. Prikazaće se informacije o kompaniji i možete da stupite u kontakt kada budete spremni da iskoristite svoj vaučer. Ako ste usluge platili putem Interneta samo ćete morati da kontaktirate kompaniju da biste zakazali sastanak. Ako ste odlučili da platite gotovinom, odštampajte vaučer, kontaktirajte kompaniju da biste zakazali sastanak i ponesite vaučer sa sobom kako biste ga pokazali prilikom vaše posete.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Ponude",
        sub_category: null,
        question:
          "Da li su navedene promotivne ponude na vašem veb sajtu sigurne za kupovinu?",
        answer:
          "<p>Da, biznisi sa kojima sarađujemo imaju registrovanu kompaniju za usluge koje pružaju.</p>",
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Ponude",
        sub_category: null,
        question:
          "Imam problem da iskoristim vaučer za promotivnu ponudu, šta da radim?",
        answer:
          '<p>Ako imate poteškoća da iskoristite vaučer, obratite se direktno kompaniji. Ako i dalje imate problem, kontaktirajte SensCare direktno putem naše <a href="/contact-us">stranice za kontakt</a>.</p>',
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Ponude",
        sub_category: null,
        question:
          "Zašto ne mogu da kupim promotivnu ponudu na vašem veb sajtu?",
        answer:
          "<p>Trenutno, SensCare ne posreduje u transakcijama između drugih kompanija i naših članova. Molimo vas da se direktno obratite kompaniji u vezi sa plaćanjem ponude.</p>",
      },
      {
        main_category: "Upravljanje profilom i sadržajem",
        category: "Promocije i Obaveštenja",
        sub_category: null,
        question:
          "Više ne želim da primam promotivne e-mailove od SensCare, kako mogu da se odjavim?",
        answer:
          '<p>Razumemo da je ponekad dobro napraviti predah od promotivnih e-mailove. Posetite svoja <strong>Podešavanja <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Vidi/Uredi Profil <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Lične Preferencije <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Preferencije i obaveštenja</strong> i onda deaktivirajte obaveštenja putem kliznog dugmeta.</p>',
      },
    ],
  },
  {
    main_category: "Plaćanje i SensCare Plan",
    id: 58,
    data: [
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "Plaćanje",
        sub_category: null,
        question:
          "Ako ste roditelj - Kako da znate koji SensCare plan je najbolji za vas?",
        answer:
          "<p>Kada birate SensCare plan uzmite u obzir svoje potrebe.Veći plan pruža vam više fleksibilnosti i izbora, što može biti važno za vas ako ste, na primer, često u putu, treba vam više dadilja, živite na više mesta itd.</p>",
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "Plaćanje",
        sub_category: null,
        question:
          "Ako tražite posao - Kako da znate koji SensCare plan je najbolji za vas?",
        answer:
          "<p>Kada birate SensCare plan uzmite u obzir svoje potrebe. Veći plan pruža vam više fleksibilnosti i izbora, kao i bolju priliku da pronađete odgovarajuću poziciju i posao.&nbsp;&nbsp; &nbsp;</p>",
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "Plaćanje",
        sub_category: null,
        question:
          "Želim da dokupim komprehnzivniji plan, kako to mogu da uradim?",
        answer:
          '<p>Drago nam je što želelite da dodatno istražite našu platformu SensCare. Da biste dokupili novi plan možete ili kliknuti &ldquo;<strong>dokupi premium plan</strong>&rdquo; na  zlatnoj traci na naslovnoj stranici ili posetite  <strong>Podešavanja <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Nalog <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Plaćanje i SensCare Plan <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> </strong> i zatim odaberite <strong>Promeni plan</strong>.Bićete upućeni da izaberete novi plan članstva.</p>',
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "Plaćanje",
        sub_category: null,
        question: "Kako mogu da promenim svoj SensCare plan?",
        answer:
          '<p>Drago nam je što želelite da dodatno istražite našu platformu SensCare. Da biste promenili plan, posetite <strong>Podešavanja <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Nalog <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Plaćanje i SensCare Plan</strong> i kliknite na Promeni plan. Bićete upućeni da izaberete novi plan članstva</p>',
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "Plaćanje",
        sub_category: null,
        question:
          "Mogu li dobiti povraćaj novca ako nisam zadovoljan/na uslugama?",
        answer:
          '<p>SensCare se trudi da pruži usluge najboljeg kvaliteta; međutim, potpuno smo svesni da očekivanja možda neće uvek biti ispunjena. Nažalost, prema našoj politici, ne postoji povraćaj novca za korišćenje usluga na našoj platformi. Mećutim, u retkim slučajevima postoji mogućnost da ostvarite pravo na povraćaj novca ako je došlo do ozbiljnih kršenja naše  <a href="/privacy-policy">Politike privatnosti</a> i&nbsp;<a href="/terms-of-use"> Uslova korišćenja</a>. SensCare zadržava pravo da odlučuje o povraćaju novca na individualnoj osnovi. Ukoliko niste zadovoljni uslugama, obavestite nas o svom iskustvu jer bismo želeli da saslušamo vaše mišljenje i učinimo vaše iskustvo prijatnijim.&nbsp;<br />\r\n&nbsp;</p>',
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "SensCare obnova pretplate",
        sub_category: null,
        question: "Šta je automatska obnova pretplate?",
        answer:
          "<p>Automatska obnavlja pretplate je usluga koju nudi SensCare kako bi se automatski produžio plan članstva neposredno pre isteka. Automatsko obnavljanje pretplate  je pozitivno ocenjeno jer nećete morati ručno da izvršite postupak obnavljanja svakog meseca. Kada odaberete SensCare plan, pretplata će se automatski obnavljati svakog obračunskog ciklusa, osim ako ne otkažete automatsko obnavljanje pre sledećeg datuma plaćanja.</p>",
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "SensCare obnova pretplate",
        sub_category: null,
        question: "Kada sam se prijavo/la na automatsko obnavljanje pretplate?",
        answer:
          "<p>Pretplatili ste se na automatsko obnavljanje kada ste aktivirali ili dokupili SensCare plan i dali vašu saglasnost klikom na dugme za automatsko obnavljanje.</p>",
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "SensCare obnova pretplate",
        sub_category: null,
        question: "Kako mogu da otkažem automatsko obnavljanje pretplate?",
        answer:
          '<p>Pretplatu možete otkazati posetom <strong>Podešavanja <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Nalog <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Plaćanje i SensCare Plan</strong> i deaktiviranjem dugmeta za  automatsko obnavljanje.</p>',
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "SensCare obnova pretplate",
        sub_category: null,
        question: "Kada će moja kreditna kartica da se naplati?",
        answer:
          '<p>Kada se prijavite za automatsko obnavljanje pretplate, SensCare će kreditnu karticu koja je sačuvana na vašem nalogu naplatiti u roku od 48 sati od datuma obnavljanja vaše pretplate u iznosu vašeg trenutnog članstva. Svoj plan članstva možete proveriti u <strong>Podešavanja <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Nalog <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Plaćanje i SensCare Plan.</strong></p>',
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "SensCare obnova pretplate",
        sub_category: null,
        question: "Kako da aktiviram automatsko obnavljanje pretplate?",
        answer:
          '<p>Možete se prijaviti za automatsko obnavljanje pretplate tako što ćete posetiti <strong>Podešavanja <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Nalog <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Plaćanje i članstvo</strong> i aktiviranjem opcije automatskog obnavljanja. Takođe, možete se prijaviti za automatsko obnavljanje pretplate kada aktivirate ili dokupite svoj SensCare plan.</p>',
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "SensCare obnova pretplate",
        sub_category: null,
        question:
          "Da li ćete me podsetiti pre nego što moja kreditna kartica istekne?",
        answer:
          "<p>SensCare trenutno ne šalje podsetnike da bi vas obavestili o isteku vaše kreditne kartice. Zato je važno da uvek imate najnovije informacije u vezi sa sačuvanim kreditnim karticama na vašem nalogu. U slučajevima kada je kartica istekla i ne možemo da naplatimo vašu kreditnu karticu, vaše članstvo se neće automatski obnavljati i moraćete ponovo da unesete podatke o plaćanju.</p>",
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "SensCare obnova pretplate",
        sub_category: null,
        question:
          "Da li ćete poslati podsetnik o isteku automatske obnove pretplate?",
        answer:
          "<p>Da, SensCare će vam poslati e-mejl najmanje 10 dana pre završetka automatske pretplate. Na primer, ako se pretplata obnavlja godišnje, poslaćemo vam e-mejl sa cenom, rokom i povezanim detaljima pre nego što naplatimo vašu kreditnu karticu.</p>",
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "SensCare obnova pretplate",
        sub_category: null,
        question:
          "Šta će se dogoditi ako otkažem automatsko obnavljanje pretplate pre isteka SensCare plana?",
        answer:
          '<p>Morate da otkažete automatsko obnavljanje pretplate najmanje 7 dana pre datuma obnavljanja kako biste izbegli dodatne troškove. Molimo vas pročitajte naše <a href="/terms-of-use">Uslove korišćenja</a> za više informacija o uslovima otkazivanja SensCare plana.</p>',
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "Plaćanje",
        sub_category: null,
        question:
          "Da li je sigurno da moja kreditna kartica bude sačuvana na SensCare?",
        answer:
          "<p>Da, vaše sačuvane informacije o kreditnoj kartici su zaštićene na platformi SensCare.</p>",
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "Plaćanje",
        sub_category: null,
        question: "Moja kreditna kartica je odbijena, šta da radim?",
        answer:
          "<p>Potpuno smo svesni da ovo može biti vrlo neprijatno iskustvo stoga je SensCare tim ovde da vam pomogne. Česti razlozi za odbijanje kreditne kartice su zato sto je kartica istekla ili se dogodi da korisnik unese pogrešan broj kreditne kartice. Još jednom proverite datum isteka kartice i da li ste tačno uneli broj vaše kreditne kartice. Ako i dalje ne možemo da obradimo vašu uplatu, pokušajte sa drugom karticom ili kontaktirajte svoju banku. Dodatne provizije banke povezane sa kupovinom mogu biti uključene u skladu sa vašim bankovnim ugovorom.</p>",
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "Plaćanje",
        sub_category: null,
        question: "Kako da uklonim kreditnu karticu sa SensCare?",
        answer:
          '<p>Da biste uklonili kreditnu karticu, posetite <strong>Podešavanja <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Nalog <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Plaćanje i SensCare Plan</strong> <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> i zatim <strong>odaberite kreditnu karticu</strong> koju želite da uklonite sa SensCare.</p>',
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "Plaćanje",
        sub_category: null,
        question: "Kako mogu da dodam novu kreditnu karticu?",
        answer:
          '<p>Da biste dodali kreditnu karticu, posetite <strong>Podešavanja <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Nalog <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10" viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">\r\n                <path d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z"></path>\r\n            </g>\r\n        </svg> Plaćanje i SensCare Plan</strong> i zatim odaberite &ldquo;<strong>dodaj novu karticu</strong>&rdquo; u gornjem desnom uglu.<br />\r\n&nbsp;</p>',
      },
      {
        main_category: "Plaćanje i SensCare Plan",
        category: "Plaćanje",
        sub_category: null,
        question:
          "Da li SensCare posreduje u novčanim transakcijama između poslodavca i zaposlenog?",
        answer:
          '<p>Trenutno SensCare ne posreduje u novčanim transakcijama između naših članova. Molimo vas da pregledate naš <a href="/safety-center">Sigurnosni centar</a> za više informacija o bezbednosnim savetima.</p>',
      },
    ],
  },
  // {
  //   main_category: "Za Biznise i Škole",
  //   id: 76,
  //   data: [
  //     {
  //       main_category: "Za Biznise i Škole",
  //       category: null,
  //       sub_category: null,
  //       question:
  //         "Kako mogu da oglašavam svoju kompaniju / ili školu na vašem veb sajtu?",
  //       answer:
  //         '<p>Ako želite da oglasite svoju kompaniju ili školu na SensCare platformi, to možete učiniti na dva načina:<br />\r\nKada napravite nalog, profil vaše kompanije biće prikazan na našoj  <a href="/">Poslovnog Direktorijuma stranici</a>. SensCare je odlično mesto za oglašavanje vaše kompanije i povezivanje sa drugim biznisima.&nbsp;<br />\r\nPostavite baner na našoj platformi i promovišite svoj brend.</p>\r\n\r\n<p>Molimo vas da posetite našu <a href="/work-with-us">Sarađujte sa nama</a> stranicu i pošaljite nam poruku kako bismo nastavili dalju komunikaciju o vašim poslovnim potrebama i kako biste dobili personalizovanu kvotu.</p>',
  //     },
  //     {
  //       main_category: "Za Biznise i Škole",
  //       category: null,
  //       sub_category: null,
  //       question:
  //         "Koji su uslovi za postavljanje moje kompanije na vaš vebsajt?",
  //       answer:
  //         "<p>SensCare nastoji da stvori sigurno okruženje za naše poslovne partnere. Da bi se vaša kompanija/škola oglasila na SensCare platformi, biznisi moraju da budu registrovani i da imaju odgovarajuće licence za rad u oblasti u kojoj pružaju usluge.</p>",
  //     },
  //     {
  //       main_category: "Za Biznise i Škole",
  //       category: null,
  //       sub_category: null,
  //       question: "Koliko košta oglašavanje mojih usluga/ponuda na SensCare?",
  //       answer:
  //         '<p>Molimo <a href="/work-with-us">pošaljite nam poruku</a> &nbsp;kako bismo nastavili dalju komunikaciju o vašim poslovnim potrebama i kako biste dobili personalizovanu kvotu.</p>',
  //     },
  //     {
  //       main_category: "Za Biznise i Škole",
  //       category: null,
  //       sub_category: null,
  //       question:
  //         "Imam sjajnu promociju svog proizvoda ili usluge, kako da postavim ponudu?",
  //       answer:
  //         '<p>Ovo je uzbudljiv trenutak. Da biste napravili novu promociju, kliknite na &ldquo;nova ponuda&rdquo; ljubičastu ikonu &nbsp; <img src="https://admin.stage.mysenscare.com/assets/cms/Group 1491.svg" /> &nbsp; u gornjem desnom uglu pored slike vašeg profila. Možete i da posetite Istoriju ponuda i izaberete &ldquo;+ novu ponudu&rdquo; ljubičasti simbol. Tada ćete biti upitani da unesete naslov ponude i napišete kratak opis. Onog trenutka kada je promotivna ponuda aktivna, mnogi članovi će početi da kupuju vašu ponudu.</p>',
  //     },
  //     {
  //       main_category: "Za Biznise i Škole",
  //       category: null,
  //       sub_category: null,
  //       question:
  //         "Koje informacije treba da sadrži moja promotivna ponuda da bi bila odobrena?",
  //       answer:
  //         "<p>Molimo pogledajte uputstva da biste videli primer uspešnog opisa promocije. Ako imate bilo kakvih pitanja, kontaktirajte nas, SensCare je uvek tu da vam pomogne.</p>",
  //     },
  //     {
  //       main_category: "Za Biznise i Škole",
  //       category: null,
  //       sub_category: null,
  //       question: "Kako mogu da uredim promotivnu ponudu?",
  //       answer:
  //         '<p>Da biste uredili promotivnu ponudu, posetite sekciju Istorija promocija <svg version="1.0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="10"\r\n            viewBox="0 0 512.000000 512.000000" height="20">\r\n\r\n            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"  stroke="none">\r\n                <path\r\n                    d="M3025 3950 l-350 -350 270 -270 270 -270 -1608 0 -1607 0 0 -500 0 -500 1607 0 1608 0 -270 -270 -270 -270 353 -353 352 -352 870 870 870 870 -873 873 -872 872 -350 -350z m1015 -735 l655 -655 -658 -657 -657 -658 -137 138 -138 137 420 420 420 420 -1823 0 -1822 0 0 200 0 200 1817 0 1818 0 -418 418 -417 417 137 138 c76 75 140 137 143 137 3 0 300 -295 660 -655z" />\r\n            </g>\r\n        </svg> Moje promocije anchor i odaberite promotivnu ponudu koji želite da uredite. Tada ćete biti preusmereni na novu stranicu na kojoj možete da kliknete &ldquo;uredi promociju&rdquo; dugme i ažurirate svoju ponudu</p>',
  //     },
  //     {
  //       main_category: "Za Biznise i Škole",
  //       category: null,
  //       sub_category: null,
  //       question: "Kako mogu da vidim koliko članova je preuzelo moje ponude?",
  //       answer:
  //         "<p>Da biste videli analitiku vaše ponude, posetite stranicu Analitika na vašem profilu, a zatim odaberite ponudu za koju želite da vidite podatke&nbsp;</p>",
  //     },
  //     {
  //       main_category: "Za Biznise i Škole",
  //       category: null,
  //       sub_category: null,
  //       question:
  //         "Šta predstavlja vaša stranica Analitike i zašto je važna za nas?",
  //       answer:
  //         '<p><img src="https://admin.stage.mysenscare.com/assets/cms/Group 2278.svg" /></p>\r\n\r\n<p>Podaci analitike pružiće sveobuhvatani uvid u to koliko su tražene ponude vaših usluge ili proizvoda na našoj platformi. Štaviše, to će vam pomoći da bolje razumete koje marketinške strategije najbolje odgovaraju vašoj kompaniji i ukoliko je potrebno, kako poboljšati svoje usluge.</p>',
  //     },
  //     {
  //       main_category: "Za Biznise i Škole",
  //       category: null,
  //       sub_category: null,
  //       question:
  //         "Mi imamo kompaniju/školu u drugoj zemlji i želeli bismo da radimo sa SensCare.Kako možemo stupiti u kontakt sa vama?",
  //       answer:
  //         '<p>Drago nam je da vas vidimo na našoj platformi! Molimo <a href="/work-with-us">Pošaljite nam poruku </a> kako biste nam rekli više o vašim poslovnim potrebama i kako zamišljate svoju saradnju sa SensCare.</p>',
  //     },
  //     {
  //       main_category: "Za Biznise i Škole",
  //       category: null,
  //       sub_category: null,
  //       question:
  //         "Može li SensCare pomoći školama u procesu odabira kandidata?",
  //       answer:
  //         '<p>Definitivno! Molimp <a href="/contact-us">Kontaktirajte nas</a> i opišite specifične potrebe i zahteve vaše škole, i naš predstavnik za ljudske resurse uskoro će biti u kontaktu sa vama.</p>',
  //     },
  //   ],
  // },
  // {
  //   main_category: "EDU prodavnica",
  //   id: 86,
  //   data: [
  //     {
  //       main_category: "EDU prodavnica",
  //       category: null,
  //       sub_category: null,
  //       question: "Šta je vaša EDU prodavnica?",
  //       answer:
  //         "<p>Naša EDU  prodavnica sadrži proizvode naših affiliate partnera. U našoj EDU prodavnici možete pronaći širok spektar igračaka i obrazovnih materijala za decu svih uzrasta.</p>",
  //     },
  //     {
  //       main_category: "EDU prodavnica",
  //       category: null,
  //       sub_category: null,
  //       question:
  //         "Spomenuli ste da vaša EDU prodavnica ima proizvode od affiliate partnera. Šta to znači?",
  //       answer:
  //         "<p>Naši affiliate partneri su kompanije koje prodaju svoje proizvode na našoj platformi. Međutim, SensCare hostuje samo njihove proizvode i ne posreduje u plaćanju ili pošiljci proizvoda.</p>",
  //     },
  //     {
  //       main_category: "EDU prodavnica",
  //       category: null,
  //       sub_category: null,
  //       question:
  //         "Zašto ne mogu da kupim EDU proizvode direktno na vašem veb sajtu?",
  //       answer:
  //         "<p>SensCare trenutno ne posreduje u plaćanju za preuzete proizvode. Ako želite da kupite proizvode iz EDU prodavnice, kliknite na dugme &lsquo;&rsquo;kupi sada&rsquo;&rsquo; na proizvodu koji želite da kupite i bićete preusmereni na vebsajt našeg partnera gde možete da kupite proizvod.</p>",
  //     },
  //     {
  //       main_category: "EDU prodavnica",
  //       category: null,
  //       sub_category: null,
  //       question:
  //         "Naručio/la sam proizvod iz EDU prodavnice, ali još uvek nije poslat i/ili isporučen.",
  //       answer:
  //         '<p>Molimo vas da budite strpljivi. Razumemo da ova situacija može da vas uznemiri, nažalost, usluge pošiljke mogu da budu usporene, naročito ako ste naručili proizvod van zemlje. Međutim, ako je kašnjenje u pošiljci ili isporuci značajno, kontaktirajte kompaniju gde ste kupili proizvod. Ako i dalje imate problema nakon što ste kontaktirali našeg poslovnog partnera, <a href="/contact-us">kontaktirajte nas</a> i podelite sa nama više informacija kako bismo vam pomogli.</p>',
  //     },
  //   ],
  // },
  {
    main_category: "SensCare opšta pitanja",
    id: 90,
    data: [
      {
        main_category: "SensCare opšta pitanja",
        category: null,
        sub_category: null,
        question: "U kojim zemljama SensCare trenutno pruža usluge?",
        answer:
          '<p>SensCare trenutno posluje u Republici Srbiji sa ciljem da proširi svoje poslovanje u zemljama EU. Međutim, SensCare ima partnere širom sveta i našim klijentima pružamo prilagođene usluge bez obzira gde se nalaze.<br />\r\n<a href="/work-with-us">Kontaktirajte nas</a> kako bismo dalje razgovarali o vašim poslovnim potrebama.<br />\r\nAžuriraćemo našu veb stranicu sa novim informacijama o poslovanju van Srbije pre nego što pokrenemo usluge u zemljama EU.<br />\r\n&nbsp;</p>',
      },
      {
        main_category: "SensCare opšta pitanja",
        category: null,
        sub_category: null,
        question: "Gde se nalaze članovi vašeg tima?",
        answer:
          "<p>Naša platforma se ponosi što sav rad obavlja online; članovi našeg tima žive širom sveta, uključujući Sjedinjene Američke Države i Evropu.</p>",
      },
      // {
      //   main_category: "SensCare opšta pitanja",
      //   category: null,
      //   sub_category: null,
      //   question: "Moram da zatražim podršku za biznis ili školu",
      //   answer:
      //     '<p>Za naše članove koji imaju plaćen plan posetite <strong>Podešavanja → Podrška</strong>. Ako još uvek niste član SensCare, prijavite se <a href="/signup">ovde </a>&nbsp;a u međuvremenu, <a href="/contact-us">nas kontaktirajte</a>  i pišite nam o svojim poslovnim potrebama.</p>',
      // },
      {
        main_category: "SensCare opšta pitanja",
        category: null,
        sub_category: null,
        question:
          "Da li SensCare ima starosno ograničenje koliko osoba mora imati godina da bi se prijavila za posao?",
        answer:
          '<p>Da, SensCare ne dozvoljava osobama mlađim od 16 godina da se oglašavaju na našoj veb stranici. Posetite stranicu <a href="/terms-of-use">Uslovi Korišćenja</a> za više informacija.</p>',
      },
    ],
  },
];

export const DATA_TEAM = [
  {
    id: 8,
    name: "Ivana Kovačević",
    nameCorrect: "Ivani",
    education: "Master specijalni edukator",
    position: "Generalni direktor",
    description:
      "Ivana je završila master studije u oblasti specijalnog obrazovanja i poseduje preko 13 godina međunarodnog iskustva u radu sa osobama sa smetnjama u razvoju, uključujući Srbiju i Sjedinjene Američke Države. Njen stručni fokus je podrška studentima sa različitim razvojnim smetnjama i poteškoćama u učenju, kao i menadžment u specijalnoj edukaciji.Ivana je radila kao konsultant za specijalno obrazovanje u Njujorku, kao specijalista za specijalno obrazovanje u internacionalnoj školi u Denveru, Kolorado, a trenutno je na poziciji direktora za podršku studentima sa smetnjama u učenju u privatnoj školi u Los Anđelesu u Kaliforniji. Ivanino iskustvo joj je pomoglo da razvije veliku stručnost u podršci u učenju, dizajnu instrukcija, kao i u menadžmentu u specijalnoj edukaciji i rehabilitaciji. Štaviše, Ivana je bila ponosna suvlasnica agencije za brigu o deci u Beogradu, Srbija; stoga, ona ima ogromno iskustvo u međunarodnom zapošljavanju profesionalaca koji pružaju usluge za decu. Ivana ima jak preduzetnički duh, a radila je i na razvoju i konsaltingu na nekoliko B2C i B2B start up-ova. Ponosi se time što je poluprofesionalni šef, a u slobodno vreme voli da čita. Ivana priča tečno srpski i engleski jezik.",
    image: "6c40f5ad-43a5-4474-91e5-6ee531135c38.jpeg",
    created_at: "2022-06-23T14:00:20.000000Z",
    updated_at: "2022-06-24T04:59:34.000000Z",
  },
  {
    id: 9,
    name: "Dr. Marija Čolić",
    education: "BCBA, LBA",
    nameCorrect: "Mariji",
    position: "Direktor poslovanja",
    description:
      "Marija Čolić, BCBA, LBA: Dr. Marija je diplomirala defektologiju i psihologiju, i doktorirala je na Fakultetu za specijalnu edukaciju i rehabilitaciju na Univerzitetu u Beogradu. Marija radi sa osobama sa autizmom više od 10 godina i bavi se primenjenom analizom ponašanja (ABA) od 2014. Trenutno predaje na Havajskom univerzitetu Manoa na prelepom ostrvu Oahu. Marija je objavila više članaka o porodičnoj stigmi i ABA-i u vodećim časopisima u ovim oblastima. U januaru 2021 godine, dobila je prestižnu Međunarodnu nagradu za istraživanje autizma od strane INSAR organizacije za svoj rad vezan za stigmatizaciju među srpskim roditeljima osoba sa autizmom. Marija od maja 2020. godine vodi besplatne ABA vebinare za stručnjake i roditelje koji imaju decu sa smetnjama u razvoju koji žive u Srbiji. Zanima je stigma u porodicama osoba sa smetnjama u razvoju i na koji način možemo podržati roditelje, kao i socijalni aspekt ABA. Marija voli surfovanje, okean i morski život.",
    image: "202206241656071898png",
    created_at: "2022-06-23T14:04:53.000000Z",
    updated_at: "2022-06-30T08:41:29.000000Z",
  },
  {
    id: 10,
    name: "Mila Širić",
    nameCorrect: "Mili",
    education: "Diplomirani Lingvista ",
    position: "Koordinator zapošljavanja",
    description:
      "Mila Širić, talentovana trilingvistkinja sa diplomom iz engleskih i američkih studija (uz dodatak u globalnom korporativnom menadžmentu) stečenom na Univerzitetu u Beču, pridružila se našem timu kao koordinator za zapošljavanje. Mila je rođena u Srbiji; međutim, tokom poslednjih 12 godina živela je u Austriji, uglavnom radeći kao instruktor engleskog i nemačkog jezika i nastavnik u Američkoj internacionalnoj školi u Beču. Stoga, Mila ima bogato iskustvo u radu sa internacionalnim studentima i duboko razume raznolikost kultura i inkluziju. Naravno, profesionalno vlada engleskim, nemačkim i srpskim jezikom. U slobodno vreme uživa u jahanju konja u prirodi, plivanju i vožnji rolerima. Takođe je strastvena ljubiteljka životinja i podržava prava životinja.",
    image: "202206241656071958png",
    created_at: "2022-06-23T14:01:19.000000Z",
    updated_at: "2023-09-12T06:28:22.000000Z",
  },
  {
    id: 11,
    name: "Faith Gobeli",
    nameCorrect: "Faith",
    education: "Master filozofije",
    position: "Marketing specijalista",
    description:
      "Faith je rođena i odrasla na Floridi i završila je master studije iz filozofije na Univerzitetu Biola u Kaliforniji. Faith se pridružila SensCare platformi kao stručnjak za marketing. Ona ima široko iskustvo u radu sa međunarodnim studentima i dobro razume raznolikost i inkluziju. Faith trenutno radi sa međunarodnim studentima na Long Beach City Koledžu u Kaliforniji. Njene glavne dužnosti uključuju pružanje podrške u nastavi i vođenje obrazovnih protokola za centar za učenje na koledžu. Faith je takođe programer sadržaja i marketinga za različite B2C i B2B kompanije. U slobodno vreme, Faith voli da piše i takođe je velika aktivistkinja za ženska prava.",
    image: "202206241656071934png",
    created_at: "2022-06-23T14:02:50.000000Z",
    updated_at: "2022-06-30T08:43:26.000000Z",
  },
  {
    id: 12,
    nameCorrect: "Dr. Sho Araiba",
    name: "Sho Araiba",
    education: "BCBA-D, LBA",
    position: "Bihejvioralni konsultant",
    description:
      "Dr. Sho je doktorirao psihologiju na Univerzitetu u Njujorku, sa naglaskom na primenjenoj analizi ponašanja (ABA). Ima preko 10 godina iskustva u oblasti ABA sa osobama sa smetnjama u razvoju, sa posebnim fokusom na autizam. Živi i radi kao BCBA-D u Honolulu, na Havajima. Njegova interesovanja su bihejviorizam i analiza ponašanja. Objavljivao je članke vezane za analizu ponašanja u vodećim časopisima. Sho se pridružio SensCare-u kao bihejvioralni konsultant za porodice sa osobama is spektra autizma. Sho priča japanski i engleski jezik.",
    image: "202206241656071917png",
    created_at: "2022-06-23T14:04:00.000000Z",
    updated_at: "2022-06-30T08:43:22.000000Z",
  },
]